import Vue from 'vue';
import * as directive from './directive';

Object.keys(directive).forEach(key => {
    Vue.directive(key, directive[key]);
});